import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=483d39e6&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=ts"
export * from "./UserDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=483d39e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483d39e6",
  null
  
)

export default component.exports